// extracted by mini-css-extract-plugin
export default {"content":"HeaderOnlyLayout_content__7wy35"};